<template>
  <div>
    <DetailSheetHeader :title="$t('waypoint_dialog.options.waypoints')" :subtitle="$t('waypoint_dialog.options.your_saved_points_on_this_map')" />

    <div class="waypoint-options">
      <DetailSheetSection>
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.show_waypoints_on_map')"
          show-toggle
          :toggle-on="showAllWaypoints"
          @click="clickedShowWaypoints"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.add_new_waypoint')"
          icon="add_circle"
          @click="addNewWaypoint"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.view_all_waypoints')"
          icon="list"
          @click="clickViewAllWaypoints"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.view_waypoint_groups')"
          icon="folder"
          @click="viewWaypointGroupsClicked"
        />
        <DetailSheetActionRow
          :label="$t('import_files.title')"
          icon="upload"
          @click="importFiles"
        />
      </DetailSheetSection>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { mapState } from 'vuex';
import { WaypointOptionsDialogPages } from '../../../utils/models/WaypointOptionsDialogPages';
import { Modal } from "bootstrap";
import { IMPORT_ENTRY_POINTS, openImportFiles } from '../../import_files/openImportFiles';
import DetailSheetActionRow from '../../../utils/shared_components/detail_sheet/DetailSheetActionRow.vue';
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';
import DetailSheetSection from '../../../utils/shared_components/detail_sheet/DetailSheetSection.vue';

export default defineComponent({
  components: {
    DetailSheetActionRow,
    DetailSheetHeader,
    DetailSheetSection,
  },
  computed: Object.assign(mapState({
    showAllWaypoints: (state) => state.waypoints.showAllWaypoints,
  })),
  methods: {
    // Import files, starting from Waypoints. This sheet closes first: a Bootstrap modal keeps
    // focus inside itself, which would lock the import dialog's buttons.
    importFiles() {
      const element = document.getElementById('waypoint-options-dialog');
      if (element) Modal.getInstance(element)?.hide();
      openImportFiles({
        ...IMPORT_ENTRY_POINTS.waypoints,
        onImported: async (outcome) => {
          if (!outcome.created.some((c) => c.destination === 'waypoints')) return;
          this.$store.dispatch('waypoints/getAllUserWaypointGroups');
          await this.$store.dispatch('waypoints/addWaypointsToMap');
        },
      });
    },
    addNewWaypoint() {
      this.$store.commit('waypoints/toggleWaypointAddingNotification');
      const element = document.getElementById('waypoint-options-dialog');
      const modal = Modal.getInstance(element)
      modal.hide();
    },
    clickViewAllWaypoints() {
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.Waypoints);
    },
    clickedShowWaypoints() {
      if (this.showAllWaypoints) {
        this.$store.dispatch('waypoints/removeWaypointsFromMap');
      } else {
        this.$store.dispatch('waypoints/addWaypointsToMap');
      }
      const element = document.getElementById('waypoint-options-dialog');
      const modal = Modal.getInstance(element);
      modal.hide();
    },
    viewWaypointGroupsClicked() {
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.WaypointGroups);
    },
  },
});
</script>

<style scoped>
.waypoint-options {
  padding: 1rem;
}
</style>
